var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrupal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72118 6.24283C10.1875 4.84024 11.5846 3.50381 12 2C12.397 3.44294 13.6988 4.72975 15.0977 6.06944L15.2949 6.25825C17.5038 8.3712 20 10.759 20 14.3474C19.9958 18.5745 16.4107 22 11.9902 22C7.57808 21.9892 4.00569 18.5678 4 14.3474C4 10.7705 6.48719 8.38525 8.68377 6.27867L8.70506 6.25825L8.72118 6.24283ZM12.2798 7L10.5668 8.67302C10.2054 9.02599 10.2116 9.58893 10.5806 9.93475L14.3299 13.4483L16.3795 15.7851C16.45 15.8655 16.5859 15.8438 16.6246 15.7459C17.436 13.6956 16.9079 11.3852 15.2738 9.83689L12.2798 7ZM8.96808 10.1379L8.7442 10.3925C7.38078 11.9427 6.77448 13.9678 7.07567 15.9655C7.70494 15.0712 8.4259 14.2379 9.22805 13.4778L10.8605 11.931L8.96808 10.1379ZM15.1184 17.131C15.1184 15.5465 11.8067 12.8276 11.8067 12.8276C11.8067 12.8276 8.49498 15.5465 8.49498 17.131C8.49498 18.7155 9.97768 20 11.8067 20C13.6357 20 15.1184 18.7155 15.1184 17.131Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrupal);
export default __webpack_public_path__ + "static/media/drupal.b78a31e5007479ad643a8dd66b076ee2.svg";
export { ForwardRef as ReactComponent };